export enum EnumTipoDeCartao {
  Pontos = 'Pontos',
  Selos = 'Selos',
  Reais = 'Reais'
}
